<template>
  <div class="ui tiny modal" ref="modal">
    <i class="close icon"></i>
    <div class="header">
      <i class="list alternate outline icon"></i>
      {{ $t("correlation") }}
    </div>
    <div class="image scrolling content">
      <div class="ui small image">
        <img
          src="/images/icons/bill_account.jpg"
          style="width: 100% !important"
        />
      </div>
      <div class="description" style="width: 100% !important">
        <div class="ui form" ref="form">
          <div class="field">
            <div class="nine wide field">
              <label for>{{ $t("status") }}</label>
              <select
                ref="status"
                class="ui selection dropdown"
                name="status"
                v-model="setup.status"
              >
                <option value="">{{ $t("select one") }}</option>
                <option value="A">{{ $t("Activo") }}</option>
                <option value="U">{{ $t("Usado") }}</option>
                <option value="D">{{ $t("Dañado") }}</option>
                <option value="P">{{ $t("Error de impresora") }}</option>
                <option value="B">{{
                  $t("Corrección de información.")
                }}</option>
              </select>
            </div>
          </div>

          <div class="ui error message"></div>
        </div>
      </div>
    </div>
    <div class="actions">
      <div class="ui blue icon right labeled deny button">
        <i class="remove icon"></i>
        {{ $t("close") }}
      </div>
      <div class="ui green icon right labeled button" @click="save">
        <i class="save icon"></i>
        {{ $t("save") }}
      </div>
    </div>
  </div>
</template>

<script>
import { local_api, error_toast } from "@/utils";
import filters from "@/filters";

export default {
  name: "CollegiateCorrelationModalIndex",
  components: {},
  props: {},
  filters: filters,
  computed: {},
  data() {
    return {
      form: undefined,
      setup: {
        status: "",
        uuid: "",
      },
    };
  },
  methods: {
    show_modal(data) {
      let vm = this;
      console.log(data);
      vm.setup.uuid = data.uuid;

      window
        .jQuery(vm.$refs.modal)
        .modal({
          allowMultiple: true,
          onVisible() {
            window.jQuery(vm.$refs.status).dropdown();
          },
          onHide() {
            vm.form.form("reset");

            vm.setup = {
              status: "",
              uuid: "",
            };
          },
        })
        .modal("show");

      vm.form = window.jQuery(vm.$refs.form).form({
        fields: {
          status: ["empty"],
        },
      });
    },
    save() {
      let vm = this;

      let isValid = vm.form.form("validate form");
      if (isValid) {
        let obj = JSON.parse(JSON.stringify(vm.setup));
        console.log(obj);
        local_api(vm, "post", "/collegiate/correlation/do-update", obj)
          .then(() => {
            window.jQuery(vm.$refs.modal).modal("hide");
            vm.$emit("success");
          })
          .catch((err) => {
            error_toast(err);
          });
      }
    },
  },
  mounted() {},
  watch: {},
  updated: function() {},
};
</script>
